<template>
  <div class="order-submit">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow">订单详情</div>
      <div class="nav-right"></div>
    </div>
    <div style="margin-top: 44px; background: #f9f9f9; padding-top: 16px">
      <div
        class="weight"
        style="margin: 0 16px 8px 16px"
        v-if="allData.status == '已取消' || allData.status == '已退款'"
      >
        订单已取消！
      </div>
      <div class="order-info fs-sm" style="padding: 0; width: calc(100% - 32px)">
        <div class="info-box">
          <div class="d-aligncnter">
            <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
              <el-image style="width: 80px; height: 64px" :src="allData.venueImg" fit="cover"></el-image>
            </div>
            <div style="margin-left: 16px; font-size: 14px; width: calc(100% - 100px)">
              <div class="weight overflow2">
                {{ allData.venueName }}-{{ allData.areaName }}({{ allData.blockName }})
              </div>
              <div class="grey mt-4">{{ allData.date }} {{ allData.timeInterval }}</div>
              <div class="grey mt-4">预约人数：{{ allData.peopleNums }}</div>
            </div>
          </div>
        </div>
        <div style="padding: 16px">
          <div class="d-aligncnter d-between" v-for="(item, index) in allData.users" :key="'friend_' + index">
            <div class="fs-xs d-aligncnter">
              {{ index + 1 }}.{{ item.name }}
              <div
                v-if="item.main"
                style="color: #fff; background: #e14c46; padding: 2px 4px; border-radius: 90px; margin-left: 8px"
              >
                预约人
              </div>
            </div>
            <div class="grey" style="margin-left: 16px">{{ item.mobile }}</div>
          </div>
        </div>
      </div>
      <div class="order-info fs-sm" style="margin-top: 8px">
        <div class="d-between">
          <div class="weight">使用须知</div>
        </div>
        <div class="grey mt-8" v-html="allData.instructionsUse"></div>
      </div>
      <div
        v-if="allData.main"
        class="order-info fs-sm"
        style="margin-top: 8px; position: relative; border-bottom: 1px dashed #e8e8e8"
      >
        <div class="decorate-left"></div>
        <div class="decorate-right"></div>
        <div class="d-between">
          <div class="weight">订单信息</div>
          <div class="d-aligncnter">
            <div
              v-if="allData.payStatus == '支付成功' && allData.invoice == '不开发票'"
              style="border-radius: 4px; border: 1px solid #8b8b8b; color: #8b8b8b; padding: 2px 4px"
              @click="pageToAddFp"
            >
              补开发票
            </div>
            <div
              style="border-radius: 4px; border: 1px solid #339571; color: #339571; padding: 2px 4px; margin-left: 8px"
              @click="pageToRefund"
              v-if="allData.payStatus == '已退款'"
            >
              退款去向
            </div>
          </div>
        </div>

        <div class="d-aligncnter mt-8">
          <div class="grey">场地单价</div>
          <div style="margin-left: 16px">￥{{ allData.unitPrice }}{{ allData.mode ? '/人' : '/场' }}</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px" v-if="allData.payStatus == '支付成功'">
          <div class="grey">实际付款</div>
          <div style="margin-left: 16px; color: #e14c46">￥{{ allData.amount }}</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">订单编号</div>
          <div style="margin-left: 16px">{{ allData.orderNum }}</div>
          <div @click="copyText" style="margin-left: 8px; border: 1px solid #888; border-radius: 4px; padding: 0 4px">
            复制
          </div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">下单时间</div>
          <div style="margin-left: 16px">{{ allData.orderTime ? allData.orderTime : '--' }}</div>
        </div>

        <div class="d-aligncnter" style="margin-top: 4px" v-if="allData.payStatus == '已退款'">
          <div class="grey">取消时间</div>
          <div style="margin-left: 16px">{{ allData.refund ? allData.refund : '--' }}</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px" v-else>
          <div class="grey">付款时间</div>
          <div style="margin-left: 16px">{{ allData.payTime ? allData.payTime : '--' }}</div>
        </div>

        <div class="d-aligncnter" style="margin-top: 4px" v-if="allData.payStatus == '支付成功'">
          <div class="grey">发票状态</div>
          <div style="margin-left: 16px">{{ allData.invoice == '不开发票' ? '未开票' : '已开票' }}</div>
        </div>
      </div>

      <div v-if="allData.main" class="order-info fs-sm">
        <div class="d-between">
          <div class="weight">改退信息</div>
        </div>
        <div class="grey mt-8" v-html="allData.retrofitInformation"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'

import { getConferenceInfo } from '@/api/api-venueOrder'
export default {
  components: {},
  data() {
    return {
      title: '订单确认',
      allData: {},
      conferenceId: '',
    }
  },
  mounted() {
    console.log('conferenceId！！')
    this.conferenceId = this.$route.query.conferenceId
    console.log('conferenceId', this.conferenceId)
    this.getInitData()
  },

  computed: {},
  methods: {
    getInitData() {
      getConferenceInfo(this.conferenceId).then((res) => {
        if (res.data.statusCode == 1) {
          this.allData = res.data.obj
        } else {
          Message.error(res.data.message)
        }
      })
    },
    pageToBack() {
      this.$router.go(-1)
    },
    drawback() {},
    pageToRefund() {
      this.$router.push({ path: '/appointment/refund', query: { conferenceId: this.conferenceId } })
    },
    pageToAddFp() {
      this.$router.push({
        path: '/appointment/invoice',
        query: { conferenceId: this.conferenceId, invoice: this.allData.invoice },
      })
    },

    copyText() {
      console.log('navigator.clipboard:', navigator.clipboard)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator.clipboard
        //   .writeText('2024010212121212349')
        //   .then(() => {
        //     Message.success('复制成功')
        //   })
        //   .catch(() => {
        //     Message.error('复制失败')
        //   })
        return navigator.clipboard.writeText('123')
      } else {
        console.log('navigator.clipboard:', window.isSecureContext)
        let areaText = document.createElement('textarea')
        areaText.value = this.allData.orderNum
        areaText.style.position = 'absolute'
        areaText.style.opacity = '0'
        areaText.style.left = '0'
        areaText.style.top = '0'
        document.body.appendChild(areaText)
        areaText.focus()
        areaText.select()
        Message.success('已复制')
        return new Promise((res, rej) => {
          document.execCommand('copy') ? res() : rej()
          areaText.remove()
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.order-submit {
  height: calc(100vh - 44px);
  background: #f9f9f9;
}
.mt-8 {
  margin-top: 8px;
}
.pt-16 {
  padding: 16px;
}
.submit {
  background: #007a4d;
  color: #fff;
  width: 100px;
  height: 44px;
  font-size: 14px;
}
.order-line {
  width: calc(100% - 32px);
  background: #fff;
  padding: 16px;
  font-size: 14px;
}
.bottom-sub {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background: #fff;
  line-height: 44px;
}
.plain-btn {
  border: 1px solid #339571;
  color: #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #fff;
}
.full-btn {
  background-color: #339571;
  color: #fff;
  border: 1px solid #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  margin: 0 16px;
  width: calc(100% - 64px);
}

.info-box {
  border-radius: 8px 8px 0 0;
  background: linear-gradient(302deg, #e6f2ed 0%, #fff8e7 100%), #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   margin: 16px;
  padding: 16px;
}
.decorate-left {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #f9f9f9;
  border-radius: 50%;
  bottom: -6px;
  left: -6px;
}
.decorate-right {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #f9f9f9;
  border-radius: 50%;
  bottom: -6px;
  right: -6px;
}
</style>
